// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
}

/* Responsive design utilities */
@media (max-width: 768px) {
  .MuiContainer-root {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(128,128,128,0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(128,128,128,0.5);
}

/* Loading animation */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.loading-pulse {
  animation: pulse 2s infinite;
}

/* Accessibility improvements */
.MuiButton-root:focus-visible,
.MuiIconButton-root:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}

/* Print styles */
@media print {
  .MuiAppBar-root,
  .MuiDrawer-root,
  .MuiButton-root {
    display: none !important;
  }
  
  .MuiContainer-root {
    max-width: none !important;
    padding: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;;EAEE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;AACF","sourcesContent":[".App {\n  min-height: 100vh;\n}\n\n/* Responsive design utilities */\n@media (max-width: 768px) {\n  .MuiContainer-root {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(128,128,128,0.3);\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(128,128,128,0.5);\n}\n\n/* Loading animation */\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.5; }\n  100% { opacity: 1; }\n}\n\n.loading-pulse {\n  animation: pulse 2s infinite;\n}\n\n/* Accessibility improvements */\n.MuiButton-root:focus-visible,\n.MuiIconButton-root:focus-visible {\n  outline: 2px solid currentColor;\n  outline-offset: 2px;\n}\n\n/* Print styles */\n@media print {\n  .MuiAppBar-root,\n  .MuiDrawer-root,\n  .MuiButton-root {\n    display: none !important;\n  }\n  \n  .MuiContainer-root {\n    max-width: none !important;\n    padding: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
